import { createContext } from "react";
const TarpContext = createContext();
export default TarpContext;
